import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { NoiseOverlay } from "@/components/NoiseOverlay";
import { CookieConsent } from "@/components/CookieConsent";

import Home from "@/pages/Home";
import QuemSomos from "@/pages/QuemSomos";
import Garantia from "@/pages/Garantia";
import PoliticaPrivacidade from "@/pages/PoliticaPrivacidade";
import PoliticaCookies from "@/pages/PoliticaCookies";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App bg-[#050505] text-[#f5f5f7] min-h-screen">
        <BrowserRouter>
          <NoiseOverlay />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/garantia" element={<Garantia />} />
            <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
          </Routes>
          <Footer />
          <CookieConsent />
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
